import {ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {callbackUri} from "../auth.config";
import {Browser} from "@capacitor/browser";
import {IonSelect, LoadingController} from "@ionic/angular";
import {catchError, Observable, of, switchMap, take} from "rxjs";
import moment from 'moment';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from "jspdf-autotable";
import { font } from '../util/pdf-fontok/Bitter-Regular-normal'
import { fontB } from '../util/pdf-fontok/Bitter-Bold-normal'
import { font2 } from '../util/pdf-fontok/Ionicons-normal'
import {KeycloakService} from "keycloak-angular";
import * as CryptoJS from 'crypto-js';
import { DataService } from '../data.service';
import { RiportSor, RiportTabla } from '../riport-pdf';
import { AuthService } from '../auth.service';
import { OAuthService } from 'angular-oauth2-oidc';

import { hetiOraszam, oraadoJogviszony } from '../shared/oraado';
import { TtfJogszabaly } from './ttf-jogszabaly';
@Component({
  selector: 'app-ttf',
  templateUrl: './ttf.component.html',
  styleUrls: ['./ttf.component.scss'],
})
export class TtfComponent  implements OnInit, OnDestroy {
  ports
  intezmenyek = [
    {id: "Váci SZC Király Endre Tec", name: "Király Endre Technikum és Szakképző Iskola"},
    {id: "Váci SZC Boronkay György", name: "Boronkay György Műszaki Technikum és Gimnázium"},
    {id: "Váci SZC Madách Imre Tech", name: "Madách Imre Technikum és Szakképző Iskola"},
    {id: "Váci SZC Petőfi Sándor Mű", name: "Petőfi Sándor Műszaki Technikum"},
    {id: "Váci SZC Petzelt József T", name: "Petzelt József Technikum és Szakképző Iskola"},
    {id: "Váci SZC Selye János Egés", name: "Selye János Egészségügyi Technikum"},
    {id: "Váci SZC I. Géza Király K", name: "I. Géza Király Közgazdasági Technikum"},
    {id: "Váci SZC Lányi Ferenc Tec", name: "Lányi Ferenc Technikum és Szakképző Iskola"},
    {id: "Váci SZC Bocskai István K", name: "Bocskai István Kollégium"},
    {id: "Váci SZC", name: "Váci Szakképzési Centrum"},
    {id: "203508", name:"Zenit Általános Iskola"}
  ]
  loading
  uuid
  port
  today = new Date();
  selectedMonth: number = this.today.getMonth() + 1; // Example: July
  selectedYear: number = this.today.getFullYear(); // Example: Year 2023
  selectedMonthS: number = this.today.getMonth() + 1; // Example: July
  selectedYearS: number = this.today.getFullYear(); // Example: Year 2023
  selectedDay: number = this.today.getDate();
  daysInMonth=[]
  csoportbontas=[]
  maxbontas=0
  osztaly=[]
  kinevezes=[]
  portsDef
  holidays
  user$ //= this.auth.isAuthenticated$.pipe(switchMap(() => this.auth.user$));
  ttf;
  userMetadata;
  sajatIntezmeny
  sajatnev=""
  hanyados = 0;
  aloldal = "1"
  weekNum=-1
  statuszok=[
    ["alert","danger","Nincs adat"],
    ["checkmark-circle-outline","success","Dolgozik"],
    ["bed","tertiary","Fizetett szabadság"],
    ["medkit","warning","Betegszabadság / táppénz"],
    ["car","secondary","Iskolai kiküldetés"],
    ["ban","dark","Fizetés nélküli szabadság"],
    ["leaf","success","Nincs tanítási órám"],
    ["globe","secondary","Digitális távoktatás"],
  ];
  isadmin = true;
  // A TTF oldal láthatóságát kizárólag az access tábla (/ttf vagy '*') dönti el.
  canViewTtf = false;

  ttfstatus;

  tankezd
  tanfelev
  akttev
  tanev


  isSelecting = false;
  selectedCells = new Set<string>();
  startCell: string | null = null;
  protected readonly parseFloat = parseFloat;
protected readonly Math = Math;
  // Tanév-lista a választóhoz (a tanevadatok tárolóból)
  tanevadatok: any[] = [];
  // Fő nézet / tanár-összesítő fül
  segment: string = 'ttf';
  // Teljes képernyős munkamód (a menü elrejtésével több hely a táblázatnak)
  fullscreen = false;
  // Soronkénti csoport/bontás szerkesztő modál állapota
  editorOpen = false;
  editorRow: any = null;
  editorGroups: any[] = [];
  teacherSearch = '';
  savingEditor = false;
  // Tantermek a csoportonkénti teremválasztóhoz (kereshető lista a modálban)
  termek: any[] = [];
  @ViewChild('ttfWork') ttfWork: ElementRef;

  /* ── Visszatöltés az órarendből ──────────────────────────────────────────
   *  A dolgok szokásos sorrendje: előbb a felosztás, utána az órarend. Csak épp nem
   *  mindig ez történik – ha az órarend külső programból jön, vagy menet közben
   *  átszervezik, akkor van óra, ami mögött NINCS felosztás-sor. A következménye
   *  csendes: a kolléga ott áll az órarendjében, de tanmenetet nem tud feltölteni,
   *  mert a jogosultságot részben a felosztás adja.
   *
   *  A gomb ELŐSZÖR megmutatja, mi keletkezne – írni csak a második kattintás ír. */
  vtNyitva = false;
  vtToltodik = false;
  vtFut = false;
  vtAdat: any = null;
  vtEredmeny: any = null;
  vtKerettanterv = true;

  async visszatoltesNyit() {
    this.vtNyitva = true;
    this.vtAdat = null;
    this.vtEredmeny = null;
    this.vtToltodik = true;
    try {
      this.vtAdat = await this.http.get(
        `/api/ttf-orarendbol/${this.akttev}/${this.sajatIntezmeny.intezmenyId}`).toPromise();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az elemzés nem sikerült.', 'error');
      this.vtNyitva = false;
    } finally {
      this.vtToltodik = false;
    }
  }

  get vtHianyzo(): any[] {
    return (this.vtAdat?.sorok || []).filter((s: any) =>
      s.allapot === 'uj' || s.allapot === 'nincs_kerettanterv');
  }

  /** Van felosztás-sor, de más óraszámmal, mint az órarendben. */
  get vtElteres(): any[] {
    return (this.vtAdat?.sorok || []).filter((s: any) => s.allapot === 'elter');
  }

  /** Felosztás-sor, ami mögött ebben a tanévben nincs órarendi óra. */
  get vtTobblet(): any[] {
    return this.vtAdat?.tobblet || [];
  }

  async visszatoltesIndit() {
    const o = this.vtAdat?.osszegzes;
    if (!o) return;
    const uzenet = [
      `Tanév: ${this.vtAdat.ev}. Az órarendből ${o.uj + (this.vtKerettanterv ? o.nincs_kerettanterv : 0)} `
        + 'felosztás-sor keletkezne,',
      `${o.erintett_munkatars} munkatársat érintve.`,
      ...(this.vtKerettanterv && o.nincs_kerettanterv
        ? [`Ehhez ${o.nincs_kerettanterv} sorhoz kerettanterv-sort is nyitunk.`] : []),
      '',
      'A meglévő sorokhoz NEM nyúlunk, és nem törlünk semmit.',
      '',
      'Folytatod?',
    ].join('\n');
    if (!confirm(uzenet)) return;

    this.vtFut = true;
    try {
      this.vtEredmeny = await this.http.post(
        `/api/ttf-orarendbol/${this.akttev}/${this.sajatIntezmeny.intezmenyId}`,
        { kerettanterv_letrehoz: this.vtKerettanterv }).toPromise();
      this.vtAdat = this.vtEredmeny?.allapot || this.vtAdat;
      this.data.sendToast(
        `${this.vtEredmeny.ttf_uj} felosztás-sor létrehozva.`, 'success');
      // A felosztás megváltozott: a képernyő a MOSTANI állapotot mutassa.
      this.getMunkatarsakNew();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A visszatöltés nem sikerült.', 'error');
    } finally {
      this.vtFut = false;
    }
  }

  constructor(public auth: AuthService,
      public oauth: OAuthService,private http: HttpClient, private changeref: ChangeDetectorRef,
              private loadingCtrl: LoadingController,private ref:ChangeDetectorRef, private data: DataService) {
    this.jog = new TtfJogszabaly(this.http, (szoveg, tipus) => this.data.sendToast(szoveg, (tipus as any) || 'success'));
  }

  /** 20/2012. EMMI r. 105. § szerinti kötelező adatok (sorszám, végzettség, jogcímek, megküldés, nyomtatvány). */
  jog: TtfJogszabaly;

  async ngOnInit(){
    await this.oauth.loadUserProfile();
      this.user$ = this.data.belepoKilet(this.oauth.getIdentityClaims()) as any;
    this.userMetadata = (await this.data.getFromStorage("userMetadata"))
    //"rendszergazda"
    //this.getMeta();
    this.uuid = this.user$.username

        this.akttev = JSON.parse(await this.data.getFromStorage("tanev")).aktualistanev
        this.tanevadatok = JSON.parse(await this.data.getFromStorage("tanevadatok"))
        // Ha az admin előkészítés alatt álló tanéven dolgozik (munkatanév), a TTF is
        // arra az évre nyíljon – a tanév-választóval továbbra is bármikor átváltható.
        try {
          const munka = await this.data.getMunkatanev();
          if (munka != null && (this.tanevadatok || []).some(t => t.id == munka)) this.akttev = munka;
        } catch (e) { /* marad az aktuális tanév */ }
        this.tanev = this.tanevadatok.filter(d => d.id == this.akttev)[0];
        this.tankezd = moment(this.tanev.tankezd).format("YYYY-MM-DD")
        this.tanfelev = moment(this.tanev.felev).format("YYYY-MM-DD")

    this.sajatnev = this.userMetadata.viselt_vez +" "+this.userMetadata.viselt_ker//this.user$.attributes.name
    //this.port = this.userMetadata.intezmenyadatok.filter(d => d.kulso == 0)[0]//{ id: this.user$.attributes.company.toString(), name: this.user$.attributes.company.toString() };
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.port = this.sajatIntezmeny
    this.intezmenyek = this.userMetadata.intezmenyadatok
                      .sort((a, b) => (a.intezmenyName > b.intezmenyName) ? 1 : ((b.intezmenyName > a.intezmenyName) ? -1 : 0))
    this.hanyados = this.sajatIntezmeny.intezmenyEtkezes
    this.userMetadata.department = await this.data.getJogkor();
    this.canViewTtf = await this.data.canIAccess(this.userMetadata.department, '/ttf');



    this.ttfstatus = await this.data.getTtfStatus(this.akttev,this.sajatIntezmeny.intezmenyId).toPromise();
    // A 105. § szerinti adatok (és a fenntartói megküldés határidejének figyelmeztetése) – háttérben.
    this.jog.betolt(this.akttev, this.sajatIntezmeny.intezmenyId);
   
      //console.log(this.port)
    this.showLoading('Adatok betöltése...').then(() => {
      //this.cacheSubscription = this.cacheService.cache$.subscribe(data => {
      //this.ports = JSON.parse(CryptoJS.AES.decrypt(sessionStorage.getItem('allomany'),"81ouyjFUpQiEZC8VX9qjDJSj0HNMajfbKvbr3wjLFKLCJOXBaqZ8Uo6ls9fTdMlv").toString(CryptoJS.enc.Utf8));
      this.getOsztalyok();
      //this.getKinevezesek();
     /* if(this.ports)
        this.getMunkatarsakNew()//this.getData(this.selectedYear, this.selectedMonth)
      else
        this.getMunkatarsakNew()*/
      //});
      


      this.weekNum = this.getWeekOfMonth(this.today);
      //this.getData(this.selectedYear, this.selectedMonth);

    });
  }

  ngOnDestroy() {
    //document.removeEventListener('mouseup', this.mouseUpEvent.bind(this));
    const doc: any = document;
    if (doc.fullscreenElement && doc.exitFullscreen) { try { doc.exitFullscreen(); } catch (e) {} }
    sessionStorage.removeItem('allomany');
  }

  setWeekNum(id){
    this.weekNum = id;
    //let dim = this.daysInMonth
    //this.daysInMonth.filter(item => item.week === id-1);
    //setTimeout(() => this.daysInMonth = dim, 0);
    this.daysInMonth = [...this.daysInMonth]
    this.changeref.detectChanges()
  }
  getWeekOfMonth(date) {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstDayOfWeek = firstDayOfMonth.getDay(); // getDay() returns 0 for Sunday, 1 for Monday, etc.
    const dayOfMonth = date.getDate();

    // Calculate full weeks to passed days in the month plus the shift of the start day of the week
    return Math.ceil((dayOfMonth + firstDayOfWeek) / 7);
  }
  weekCount(mode=0) {

    // month_number is in the range 1..12

    var firstOfMonth = new Date(this.selectedYear, this.selectedMonth-1, 1);
    var lastOfMonth = new Date(this.selectedYear, this.selectedMonth, 0);

    var used = firstOfMonth.getDay() + 6 + lastOfMonth.getDate();



    return new Array(Math.floor( used / 7));

  }

  searchM(){
    this.selectedYear = this.selectedYearS
    this.selectedMonth = this.selectedMonthS
    this.getData(this.selectedYear, this.selectedMonth)
  }

  resetM(){
    this.selectedMonth = this.today.getMonth() + 1; // Example: July
    this.selectedYear = this.today.getFullYear(); // Example: Year 2023
    this.selectedMonthS = this.today.getMonth() + 1; // Example: July
    this.selectedYearS = this.today.getFullYear(); // Example: Year 2023
    this.getData(this.selectedYear, this.selectedMonth)
  }

  /*async getMeta() {
    //let u = await this.auth.user$.pipe(take(1)).toPromise();

    if (this.user$) {
      // Extract the user_metadata claim from the ID token
      this.userMetadata = this.user$.attributes;
      this.sajatIntezmeny = this.intezmenyek.filter(it => it.id == this.user$.attributes.company.toString())[0];

    } else {
    }
  }*/
  async getMeta() {
    //let u = await this.auth.user$.pipe(take(1)).toPromise();


    if (this.user$) {

    /*  // Extract the user_metadata claim from the ID token
      this.userMetadata = this.user$.attributes;
      if(!this.ports.filter((item:any)=> item.oktazon == this.user$.attributes.company)[0])
        this.userMetadata["data"] = this.ports.filter((item:any)=> item.oktazon == this.user$.id)[0];
      else
        this.userMetadata["data"] = this.ports.filter((item:any)=> item.oktazon == this.user$.attributes.company)[0];
      //console.log(this.ports)
      this.sajatIntezmeny = this.intezmenyek.filter(it => it.id == this.userMetadata["data"].om.toString())[0];
*/
    } else {
    }
  }

  selectChanged(e){
    this.showLoading('Adatok lekérése...');
    //console.log(e)
    this.ports = this.portsDef.filter(d => d.om == e[0].om).sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0));
    //this.sajatIntezmeny = e[0]
    this.sajatIntezmeny = JSON.parse(this.userMetadata.intezmenyadatok).filter(d => d.kulso == 0)[0]
    //console.log(this.sajatIntezmeny)
    this.getData(this.selectedYear, this.selectedMonth);

  }

  async showLoading(msg) {
    this.loading = await this.loadingCtrl.create({
      message: msg,
    });

    this.loading.present();
  }

  getMunkatarsakNew(){
    this.http
      .get(
        '/api/nyilvantartas/allomany/'+this.sajatIntezmeny.intezmenyId,//'https://idp.zenit.cronom.it/admin/realms/master/users?q=title:oktató',
        {}
      )
      .subscribe({
        next: (response: any) => {
          //console.log(response);

          response.forEach((element) => {
            element.user_id = element.id;
            element.name == element.viselt_vez + " "+ element.viselt_ker
            element.intezmenyadatok = JSON.parse(element.intezmenyadatok)
            element.kinevezes = "";
            element.orakedvezmeny=0;
            element.of=false
            this.kinevezes.forEach(s=>{
              if(s.adid == element.adid){
                if(s.kinevezesek!="[null]"){
                s.kinevezesek = JSON.parse(s.kinevezesek)
                s.kinevezesek.forEach(f => {
                  if(f.kod=="OF") element.of=true
                  element.kinevezes = element.kinevezes+" "+f.kod+",";
                  element.orakedvezmeny+=f.ora;
                });}
              }
            })
          });

          this.ports = response.filter(d => {
            
            for(let i = 0; i< d.intezmenyadatok.length; i++){
              if(d.intezmenyadatok[i].intezmenyId == this.sajatIntezmeny.intezmenyId){
                d.intezmenyadatok = d.intezmenyadatok[i]
                if(d.intezmenyadatok.ttf==0) return false
                return true;

              }
            }
            return false;
          }).sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0));
          this.portsDef = response.sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0)) //= response.sort((a, b) => (a.viselt_vez > b.viselt_vez) ? 1 : ((b.viselt_vez > a.viselt_vez) ? -1 : 0));
            //this.portsDef = response.filter(d => d.attributes?.title != "tanuló").sort((a, b) => (a.attributes.name > b.attributes.name) ? 1 : ((b.attributes.name > a.attributes.name) ? -1 : 0));
            //this.ports = response.filter(d => d.attributes?.title != "tanuló" && d.attributes?.company == this.sajatIntezmeny.id).sort((a, b) => (a.attributes.name > b.attributes.name) ? 1 : ((b.attributes.name > a.attributes.name) ? -1 : 0));
          this.getData(this.selectedYear, this.selectedMonth)
          this.getMeta()

        },
        error: (error) => {
          console.error('Error fetching data:', error);
          // Hiba esetén ne ragadjon fent a betöltés-spinner (idempotens dismiss).
          try { this.loading?.dismiss(); } catch (e) { }
        },
      });
  }

  napKer(datum){
    return moment(datum).utcOffset(0, false) //new Date(datum)
  }

  napOra(d1,d2){
    let now = moment(d2); //todays date
    let end = moment(d1); // another date
    let duration = moment.duration(now.diff(end));
    let h = duration.asHours();
    return h
  }

  isWeekend(d){
    return new Date(this.selectedYear, this.selectedMonth, d).getDay() === 0 || new Date(this.selectedYear, this.selectedMonth, d).getDay() === 6;
  }

  isHoliday(d){
    let isHoliday = false;
    for (let it of this.holidays) {
      if (new Date(it.date).setHours(0, 0, 0, 0) == new Date(this.selectedYear, this.selectedMonth, d).setHours(0, 0, 0, 0)) {
        isHoliday = true
        break;
      }
    }
    return isHoliday
  }
  getOsztalyok(){
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer `
    );
    this.http
      .get(
        '/api/nyilvantartas/osztaly/'+this.akttev+'/'+this.sajatIntezmeny.intezmenyId,
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response:any) => {
          // Osztályok rendezése évfolyam (szám) majd betűjel szerint (7 előbb, mint 10)
          this.osztaly = (response || []).sort((a, b) => this.osztalyCompare(a, b))
          this.getTermek()
          this.getKinevezesek()

        },
        error: (error) => {
          console.error('Error fetching data:', error);
          try { this.loading?.dismiss(); } catch (e) { }
        },
      });
  }
  // Tantermek betöltése a csoport-modál teremválasztójához. A tanterem törzs a
  // tanévhez kötött (ev): elsődlegesen az aktuális tanév id-jával kérjük le, és ha
  // az üres, a tanévkezdés naptári évével is megpróbáljuk (a két érték nem minden
  // bérlőnél esik egybe, üres lista esetén viszont nem lenne teremválasztó).
  getTermek(){
    const iid = this.sajatIntezmeny.intezmenyId;
    this.data.getTanterem(this.akttev, iid).subscribe({
      next: (response:any) => {
        const lista = Array.isArray(response) ? response : [];
        if (lista.length) { this.setTermek(lista); return; }
        const ev2 = this.tanev?.tankezd ? moment(this.tanev.tankezd).format('YYYY') : null;
        if (!ev2 || ev2 == this.akttev) { this.setTermek(lista); return; }
        this.data.getTanterem(ev2, iid).subscribe({
          next: (r2:any) => this.setTermek(Array.isArray(r2) ? r2 : []),
          error: () => this.setTermek([]),
        });
      },
      error: (error) => { console.error('Error fetching data:', error); this.setTermek([]); },
    });
  }

  private setTermek(lista){
    this.termek = lista.sort((a, b) =>
      String(a?.name || '').localeCompare(String(b?.name || ''), 'hu', { numeric: true }));
    try { this.ref.detectChanges(); } catch (e) {}
  }

  getKinevezesek(){
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer `
    );
    this.http
      .get(
        '/api/nyilvantartas/kinevezes/'+this.akttev+'/'+this.sajatIntezmeny.intezmenyId,
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response:any) => {
          this.kinevezes = response
          console.log(response)
          this.getMunkatarsakNew()
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          try { this.loading?.dismiss(); } catch (e) { }
        },
      });
  }

  getHolidays(returner=false): Observable<any>{

    //console.log('Access Token:', token);
    if(returner)
      return this.http
        .get(
          '/api/nyilvantartas/holiday',
          {
            //headers: headers,
          }
        )
    else
    {
      const headers = new HttpHeaders().set(
        'Authorization',
        `Bearer `
      );
      this.http
        .get(
          '/api/nyilvantartas/holiday',
          {
            //headers: headers,
          }
        )
        .subscribe({
          next: (response) => {
            this.holidays = response

          },
          error: (error) => {
            console.error('Error fetching data:', error);

          },
        });
      return null;
    }


    


  }

  getColor(s,k){
    if(Math.round(s)==Math.round(k))
    return "bg-success";
  else if(k-s < 0)
    return "bg-danger";
  else if(k-s >= 3 && k-s < 6)
    return "bg-warning";
  else  return "bg-info";
  }
  isBontva(s, i, k=0, e=0, o=0, text=0){
    let classok = "";
    if(text==1 && o==e && e!=0) return "text-success"
    if(text==1 && e>o && e!=0) return "text-danger"
    if(text==0 && o==e && e!=0) classok = classok+" stripe";
    if(text==0 && e>o && e!=0) classok = classok+" stripe-red";
    if(text==0 && k>0 && o!=e)classok = classok+" bg-info";
    if(text==0 && s.length>1 && s.length-i>1) 
      classok=classok+" bontva"; 
    
    return classok;
  }
  refreshView(e,t,oktazon,id=null){
    //console.log(t)
    //this.ttf=[];
    this.ref.detectChanges()
    if(id==null)
    this.http
      .post(
        '/api/ttf',[e.target.value,t.id,oktazon,this.akttev,this.sajatIntezmeny.intezmenyId],
        /*{
          //headers: headers,
        }*/
      )
      .subscribe({
        next: (response:any) => {
          console.log(response)
          this.populateDaysInMonth();
  }
})
else if(id!=null && e.target.value==0)
this.http
      .delete(
        '/api/ttf/'+id,
        /*{
          //headers: headers,
        }*/
      )
      .subscribe({
        next: (response:any) => {
          console.log(response)
          this.populateDaysInMonth();
  }
})
else
this.http
      .patch(
        '/api/ttf/'+id,[e.target.value]
        /*{
          //headers: headers,
        }*/
      )
      .subscribe({
        next: (response:any) => {
          console.log(response)
          this.populateDaysInMonth();
  }
})
    
  }
  async populateDaysInMonth(response=null) {
    
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer `
    );
    this.http
      .get(
        '/api/ttf2/'+this.akttev+'/'+this.sajatIntezmeny.intezmenyId,
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response:any) => {
          for (let g of this.ports) {
           
              g.osszora = 0;
           
          }

          // 1) Nyers sorok: tantárgy × ÉVFOLYAM (a ttf/csoport ehhez kötött)
          const raw = response.filter((value, index, self) =>
            index === self.findIndex((t) => (t.id === value.id)))
          raw.forEach(element => {
            element.evfolyam = JSON.parse(element.evfolyam)
            if(element.ttfel == "[null]") element.ttfel = []
            else element.ttfel = JSON.parse(element.ttfel)
            // Tanári összóra: az évfolyam-szintű hozzárendelésekből, MINDEGYIK EGYSZER
            // (így a több osztályt átfogó csoport nem duplázódik).
            for (let f of element.ttfel) {
              if(!f) continue;
              f.hasMatch = this.ports.some(a => a.adid == f.munkatars);
              // A MÁSIK tanév (vagy törölt) csoportjára mutató sor maradvány: a rácsban
              // kiemelve látszik és törölhető, de a tanár óraszámába nem számít bele.
              if (this.idegenSor(f)) continue;
              for (let g of this.ports) if(g.adid == f.munkatars) g.osszora += Number(f.db) || 0;
            }
          });
          // 2) Kibontás: EGY SOR / (tantárgy × osztály). Egy osztály sorában azok a
          //    csoportok jelennek meg, amelyek lefedik az adott osztályt (csoport_osztaly),
          //    illetve az egész-osztályos (OSZTALY) hozzárendelések.
          const rows: any[] = [];
          for (const r of raw) {
            const grade = r.evfolyam?.evfolyam;
            const classes = (this.osztaly || []).filter(o => o.evfolyam == grade);
            if (classes.length === 0) {
              r._allttfel = r.ttfel;
              r.eddigi = this.parhuzamosOra(r.ttfel);
              rows.push(r);
              continue;
            }
            for (const o of classes) {
              //  Az osztályhoz NEM kötött csoport (sem csoport_osztaly, sem órarendi óra nem
              //  mondja meg az osztályát – ilyen a másik tanévre mutató maradvány is) az
              //  évfolyam minden osztályánál megjelenik. Korábban sehol: a sor és az óraszáma
              //  egyszerűen eltűnt a képernyőről.
              const forClass = (r.ttfel || []).filter(f => f && f.munkatars && (
                (f.csoport && f.csoport.id === 'OSZTALY') ||
                (f.csoport && (f.csoport.osztalyok || []).some(x => x.id === o.id)) ||
                (f.csoport && !(f.csoport.osztalyok || []).length)
              ));
              rows.push({
                ...r,
                evfolyam: { ...r.evfolyam, id: o.id, osztaly: o.osztaly, of: o.of },
                ttfel: forClass,
                _allttfel: r.ttfel,
                _osztalyId: o.id,
                // A bontott csoportok PÁRHUZAMOS órák → az osztály lefedettsége nem az
                // óraszámok összege, hanem a (párhuzamos) csoportok legnagyobb óraszáma.
                eddigi: this.parhuzamosOra(forClass),
              });
            }
          }
          this.ttf = rows;
          //  A diagnosztikát MINDIG lekérjük, nem csak üres rácsnál. A gyakoribb eset
          //  ugyanis nem az üres, hanem a HIÁNYOS rács: egy felmenő évfolyam (pl. új 6.)
          //  osztálya addig nem jelenik meg, amíg arra az évfolyamra nincs óraterv az
          //  adott tanévben – ez korábban néma hiány volt.
          this.diagnosztikaBetolt();
          try {
            // Rendezés osztály (évfolyam-szám majd betűjel) majd tantárgy szerint
            this.ttf.sort((a,b)=> this.osztalyStrCompare(a.evfolyam?.osztaly, b.evfolyam?.osztaly)
              || String(a.nev||'').localeCompare(String(b.nev||''), 'hu'))
          } catch (e) {
            console.error(e)
          }
          // A tanári összóra (ports[].osszora) itt frissült → a "Tanárok óraszáma"
          // fül azonnal újraszámoljon.
          this.ports = [...this.ports];
          try { this.ref.detectChanges(); } catch (e) {}
          try {
            this.loading.dismiss();
          } catch (e) {
          }
          /*for (let i = 0; i < this.ports.length; i++) {
            this.csoportbontas[i] = []
            this.maxbontas[i] = 0
            for (let element of this.ttf) {
              if (!this.daysInMonth[element.id]){
                this.daysInMonth[element.id] = [];
                this.daysInMonth[element.id]["s"] = 0;
                
                this.daysInMonth[element.id]['port'] = [];
                this.daysInMonth[element.id]['portsz'] = 0;
              }
              if (!this.daysInMonth[element.id][i]){
                this.daysInMonth[element.id][i] = {munkatars:"-",db:"-",csoport:[]};
                
              }
              let hmax=JSON.parse(element.ttfel).filter(d=>{return d!=null && d.munkatars!=null}).length
              
              if(this.maxbontas[i]<hmax) this.maxbontas[i]=hmax
              this.daysInMonth[element.id]["r"] = this.maxbontas[i];
              if(this.csoportbontas[i].length==0)
              for(let k=0; k<this.getAbs(this.maxbontas[i]-hmax);k++){
                //console.log(this.getAbs(this.maxbontas-hmax))
                this.csoportbontas[i].push({munkatars:"-",db:"-",csoport:[]})
              }
              
              for (let element2 of JSON.parse(element.ttfel)) {
                  if(element2==null) continue;
                let j = 0;
                //this.csoportbontas[i][j]={munkatars:"-",db:"-",csoport:[]}
                
                //this.csoportbontas[i][j] = []
              if (element2.munkatars == this.ports[i].oktazon) {
                //console.log(element2)
                this.daysInMonth[element.id][i] = element2;
                this.daysInMonth[element.id]['port'] = this.ports[i];
                this.daysInMonth[element.id]['portsz'] = i;
                this.csoportbontas[i].push(element2)
                //this.csoportbontas[i][j] = element2
                //console.log(this.csoportbontas)
                this.daysInMonth[element.id]["s"] += element2.db;
                this.daysInMonth[element.id]["r"] = JSON.parse(element.ttfel).length;
                //break;
              } j++;
            }
            }
            try {
              this.loading.dismiss();
            } catch (e) { 
            }
            /*if (!this.daysInMonth[i]){
              this.daysInMonth[element.tantargy][i] = {munkatars:"-",db:"-"};
            }*
          } console.log(this.csoportbontas)
          console.log(this.ttf)*/
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });

    //console.log(this.daysInMonth)
  }

  getAbs(d){
    return Math.abs(d)
  }
  changeKer(user,mit,mire){
    console.log(mit)
    this.ports.forEach(d=>{
      if(d.adid==user.adid) d.adatok[mit]=mire
      this.ref.detectChanges()
    })

  }

  getData(y, m) {
    this.getHolidays(true).pipe(
      switchMap((response1: any[]) => {
        // Pre-process holidays into a Set for faster lookup
        const holidaysSet = new Set(response1.map(holiday =>
          new Date(holiday.date).toDateString()));
        return this.http.get(`/api/nyilvantartas/riport/${y}/${m}/${this.sajatIntezmeny.intezmenyId}`).pipe(
          switchMap((response: any[]) => {
            // Process data here
            const days = new Date(y, m, 0).getDate();
            this.ports.forEach((item: any) => {
              item.nyilv = new Array(days).fill(0);
              item.osszora = 0;
              console.log(response.length)
              for (let i = 0; i < days; i++) {
                const currentDate = new Date(y, m - 1, i + 1);
                let isHoliday = holidaysSet.has(currentDate.toDateString());
                let isWeekend = currentDate.getDay() === 0 || currentDate.getDay() === 6;

                if (isWeekend) {
                  item.nyilv[i] = 1;
                } else if (isHoliday) {
                  item.nyilv[i] = 2;
                } else {
                  for (let j = 0; j < response.length; j++) {
                    if ((response[j].user == item.adid || response[j].user == item.auth0id) && new Date(response[j].start).getDate() === i + 1) {
                      item.nyilv[i] = response[j];
                      item.osszora += this.napOra(response[j].start, response[j].end);
                      break;
                    }
                  }
                }
              }
            });

            // Assuming this.populateDaysInMonth() processes the final data and updates the UI accordingly
            this.populateDaysInMonth(response); // Now called with the correct context

            return of({}); // Complete the observable chain
          })
        )
      }),
      catchError(error => {
        console.error('Error fetching data:', error);
        // Hiba esetén a populateDaysInMonth már nem fut le, ezért itt zárjuk a spinnert.
        try { this.loading?.dismiss(); } catch (e) { }
        alert('Nem sikerült betölteni az adatokat! Kérjük próbálja újra.');
        return of({}); // Handle errors appropriately
      })
    ).subscribe();
  }

  getDataOld(y, m) {
    this.getHolidays()
    //console.log(y)
    // console.log(m)

    // console.log('Access Token:', token);
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer `
    );
    this.http
      .get('/api/nyilvantartas/riport/' + y + '/' + m, {
        //headers: headers,
      })
      .subscribe({
        next:(response:any) => {
          // console.log(response)
          const days = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
          this.ports.forEach((item:any)=>{
            item.nyilv=[];
            item.osszora = 0

            for(let i = 0; i<days; i++) {
              let isHoliday = false;
              let isWeekend = new Date(this.selectedYear, this.selectedMonth - 1, i + 1).getDay() === 0 || new Date(this.selectedYear, this.selectedMonth - 1, i + 1).getDay() === 6;

              item.nyilv[i] = 0;


              if (isWeekend) {
                item.nyilv[i] = 1
              } else {
                for(let k=0;k<this.holidays.length;k++){
                  // console.log(new Date(this.holidays[k].date).getMonth()+1 +"-"+this.selectedMonth)
                  if(new Date(this.holidays[k].date).getDay() == i+3 && new Date(this.holidays[k].date).getMonth()+1 == this.selectedMonth && new Date(this.holidays[k].date).getFullYear() == this.selectedYear){
                    item.nyilv[i] = 2
                    isHoliday = true
                    break;
                  }
                }
                if(!isHoliday)
                  for (let j = 0; j < response.length; j++) {
                    let daysn = new Date(response[j].start).getDate();

                    if (response[j].user == item.user_id && daysn == i + 1) {
                      item.nyilv[i] = response[j]
                      item.osszora += this.napOra(response[j].start,response[j].end)

                      break;
                    }
                  }
              }
            }

          })
          this.daysInMonth = [];
          this.populateDaysInMonth(response);
          //console.log(this.ports)
          try {
            this.loading.dismiss();

          } catch (error) {
            console.log("error: "+error)
          }
        },
        error:(error) => {
          console.error('Error fetching data:', error);
          alert(
            'Nem sikerült betölteni az adatokat! Kérjük próbálja újra.'
          );
        }
      });


  }

  // A bontott csoportok PÁRHUZAMOS órák → az osztály lefedettsége a csoportok
  // LEGNAGYOBB óraszáma (nem az összegük). Pl. 3 óra 2 csoportra bontva = 3 óra.
  parhuzamosOra(ttfel): number {
    const arr = (ttfel || []).filter(f => f && f.munkatars && !this.idegenSor(f)).map(f => Number(f.db) || 0);
    return arr.length ? Math.max(...arr) : 0;
  }

  /** Másik tanév (vagy törölt) csoportjára mutató felosztás-sor – a backend jelöli. */
  idegenSor(f: any): boolean {
    return !!(f && f.csoport && f.csoport.idegen);
  }

  // ---- Osztály-rendezés: évfolyam (szám) majd betűjel szerint ----
  osztalyStrCompare(a, b): number {
    a = String(a == null ? '' : a).trim();
    b = String(b == null ? '' : b).trim();
    const na = parseInt((a.match(/^\d+/) || ['0'])[0], 10);
    const nb = parseInt((b.match(/^\d+/) || ['0'])[0], 10);
    if (na !== nb) return na - nb;
    return a.localeCompare(b, 'hu');
  }
  osztalyCompare(a, b): number {
    const ea = parseInt(a?.evfolyam ?? 0, 10) || 0;
    const eb = parseInt(b?.evfolyam ?? 0, 10) || 0;
    if (ea !== eb) return ea - eb;
    return String(a?.osztaly || '').localeCompare(String(b?.osztaly || ''), 'hu');
  }

  // ---- Tanév váltás: újratölti a törzs- és TTF-adatokat az új évre ----
  async changeEv(e) {
    const val = e?.detail?.value ?? e;
    if (val == null) return;
    this.akttev = parseInt(val, 10);
    this.tanev = this.tanevadatok.filter(d => d.id == this.akttev)[0];
    this.ttf = null;
    this.showLoading('Adatok betöltése...');
    // Ha a TTF-státusz lekérése elhasal, a lánc (getOsztalyok → … → getData) el sem
    // indul, ezért itt bezárjuk a spinnert, nehogy fent ragadjon.
    this.jog.szerk = null;
    this.jog.betolt(this.akttev, this.sajatIntezmeny.intezmenyId);
    try {
      this.ttfstatus = await this.data.getTtfStatus(this.akttev, this.sajatIntezmeny.intezmenyId).toPromise();
    } catch (e) {
      console.error('Error fetching data:', e);
      try { this.loading?.dismiss(); } catch (e2) { }
      return;
    }
    this.getOsztalyok();
  }

  // Teljes képernyős munkamód: valódi Fullscreen API-val (ez ténylegesen kiterül a
  // menü fölé). A modál NEM ion-modal, hanem sima inline overlay a .ttf-work-ön belül,
  // így a fullscreen top-layerben is megjelenik.
  toggleFullscreen() {
    const el: any = this.ttfWork?.nativeElement;
    const doc: any = document;
    if (!doc.fullscreenElement && !doc.webkitFullscreenElement) {
      if (el?.requestFullscreen) el.requestFullscreen();
      else if (el?.webkitRequestFullscreen) el.webkitRequestFullscreen();
      this.fullscreen = true;
    } else {
      if (doc.exitFullscreen) doc.exitFullscreen();
      else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen();
      this.fullscreen = false;
    }
    this.ref.detectChanges();
  }

  @HostListener('document:fullscreenchange')
  @HostListener('document:webkitfullscreenchange')
  onFullscreenChange() {
    const doc: any = document;
    this.fullscreen = !!(doc.fullscreenElement || doc.webkitFullscreenElement);
    this.ref.detectChanges();
  }

  // ================= Csoport / bontás szerkesztő modál =================
  // Egy tantárgy(×évfolyam) sorhoz tartozó csoportok (bontás) szerkesztése.
  // A "whole class" (OSZTALY sentinel) hozzárendeléseket nem érinti.
  editorClassId: any = null;
  openEditor(t) {
    this.editorRow = t;
    this.editorClassId = t?._osztalyId || t?.evfolyam?.id || null;
    this.teacherSearch = '';
    // A modál CSAK az adott OSZTÁLY csoportjait kezeli (a t.ttfel már az osztályra
    // szűrt: csoport_osztaly-lefedettség szerint). Korábban az évfolyam-szintű
    // _allttfel-t töltötte, ezért egy másik osztály (pl. 9.b) kitöltése átjött ide
    // (9.e) előkitöltve, és átíráskor a másik osztályét is felülírta.
    const arr = Array.isArray(t.ttfel) ? t.ttfel : [];
    // Egy csoporthoz TÖBB tanár is tartozhat (társtanítás, pl. 2 osztályfőnök az OF-órán):
    // a nyers ttfel csoportonként több sort ad → csoport-id szerint összevonjuk, a tanárokat
    // (adid) tömbbe gyűjtjük, és megjegyezzük az eredeti (ttfId,tanár) párokat a mentés-diffhez.
    //  EGÉSZ OSZTÁLYOS beosztás (ttf.csoport IS NULL): a rácsban látszik, a szerkesztőből
    //  viszont eddig kimaradt – így úgy tűnt, „nincs ott semmi", és mentéskor a meglévő
    //  beosztás mellé egy ÚJ csoport került (duplázva az óraszámot). Most külön, névtelen
    //  „Egész osztály" tételként jön be: a tanárok és az óraszám szerkeszthető, csoportot
    //  nem hozunk létre hozzá.
    const egeszSorok = arr.filter((f: any) => f && f.munkatars && f.csoport && f.csoport.id === 'OSZTALY');
    const egeszCsoport = egeszSorok.length ? {
      csoportId: null,
      egeszOsztaly: true,
      name: 'Egész osztály',
      db: egeszSorok.reduce((m: number, f: any) => Math.max(m, Number(f.db) || 0), 0),
      terem: null,
      teremSearch: '',
      osztalyok: [],
      munkatarsak: [...new Set(egeszSorok.map((f: any) => f.munkatars))],
      origAssignments: egeszSorok.map((f: any) => ({ ttfId: f.id, munkatars: f.munkatars })),
    } : null;

    const byGroup = new Map<any, any>();
    for (const f of arr) {
      if (!f || !f.munkatars || !f.csoport || !f.csoport.id || f.csoport.id === 'OSZTALY') continue;
      const cid = f.csoport.id;
      if (!byGroup.has(cid)) {
        byGroup.set(cid, {
          csoportId: cid,
          // Másik tanév / törölt csoport: csak a kiírás törölhető, a csoporthoz nem nyúlunk.
          idegen: this.idegenSor(f),
          idegenEv: f.csoport.idegenEv || null,
          name: f.csoport.name || '',
          db: f.db,
          terem: f.csoport.terem || null,
          teremSearch: '',
          osztalyok: (f.csoport.osztalyok || []).map(o => o.id),
          munkatarsak: [],
          origAssignments: [],
        });
      }
      const g = byGroup.get(cid);
      if (g.munkatarsak.indexOf(f.munkatars) === -1) g.munkatarsak.push(f.munkatars);
      g.origAssignments.push({ ttfId: f.id, munkatars: f.munkatars });
      if ((Number(f.db) || 0) > (Number(g.db) || 0)) g.db = f.db;
    }
    this.editorGroups = Array.from(byGroup.values());
    if (egeszCsoport) this.editorGroups.unshift(egeszCsoport);
    if (this.editorGroups.length === 0) this.addGroup();
    this.editorOpen = true;
    this.ref.detectChanges();
  }

  closeEditor() {
    this.editorOpen = false;
    this.editorRow = null;
    this.editorGroups = [];
    // A modálban azonnal törölt kiírás/csoport után a rács is a mostani állapotot mutassa.
    if (this.editorValtozott) { this.editorValtozott = false; this.populateDaysInMonth(); }
  }

  /** A szerkesztőben már végrehajtott (azonnali) törlés történt – bezáráskor frissítünk. */
  private editorValtozott = false;

  /** A csoport (vagy egész osztályos tétel) összes tanár-hozzárendelésének törlése. */
  private async kiirasTorles(g: any) {
    for (const a of (g.origAssignments || [])) {
      this.assertTtfOk(await this.http.delete('/api/ttf/' + a.ttfId).toPromise());
    }
    g.origAssignments = [];
    this.editorValtozott = true;
  }

  addGroup() {
    const n = this.editorGroups.length + 1;
    this.editorGroups.push({
      csoportId: null,
      name: (this.editorRow?.nev ? this.editorRow.nev + ' ' : '') + (this.editorRow?.evfolyam?.osztaly || '') + '/' + n,
      db: this.editorRow?.db || 1,
      terem: null,
      teremSearch: '',
      // Új csoport alapból az aktuális sor osztályát tartalmazza
      osztalyok: this.editorClassId ? [this.editorClassId] : [],
      munkatarsak: [],
      origAssignments: [],
    });
  }

  // A bontás (csoportszám) beállítása: a tömböt N eleműre húzza.
  setGroupCount(n) {
    n = parseInt(n, 10) || 0;
    while (this.editorGroups.length < n) this.addGroup();
    while (this.editorGroups.length > n) this.editorGroups.splice(this.editorGroups.length - 1, 1);
  }

  /**
   *  Csoport eltávolítása a bontásból.
   *
   *  A hibát NEM nyeljük el: korábban a sikertelen szerveroldali törlés is eltüntette a
   *  sort a képernyőről, a csoport viszont bent maradt az adatbázisban, és újratöltéskor
   *  visszajött. Ha a szerver megtagadja (órarendi óra vagy faliújság hivatkozik rá),
   *  megmondjuk, mi az, és felajánljuk a kényszerített törlést.
   */
  async removeGroup(i) {
    const g = this.editorGroups[i];
    //  Egész osztályos tétel, illetve másik tanév csoportjára mutató sor: CSAK a kiírást
    //  (a tanár-hozzárendelést) töröljük. Korábban az egész osztályos tétel csak a
    //  képernyőről tűnt el, az adatbázisban bent maradt; a régi tanév csoportját pedig
    //  törölni sem szabad (a lezárt tanév adatához nem nyúlunk).
    if (g && (g.egeszOsztaly || g.idegen || !g.csoportId)) {
      if ((g.origAssignments || []).length) {
        if (!confirm('Törlöm ezt a kiírást a tantárgyfelosztásból?')) return;
        try {
          await this.kiirasTorles(g);
        } catch (e) {
          alert('A törlés nem sikerült!\n\n' + this.hibaSzoveg(e));
          return;
        }
      }
      this.editorGroups.splice(i, 1);
      this.ref.detectChanges();
      return;
    }
    if (g && g.csoportId) {
      const torol = async (kenyszer = false) => this.http
        .delete('/api/csoport/' + g.csoportId + (kenyszer ? '?kenyszer=1' : '')).toPromise();
      try {
        await torol();
      } catch (e: any) {
        const hiba = e?.error;
        if (e?.status === 409 && hiba?.kenyszerithet) {
          //  A csoportnak órái vannak: a szokásos kérés ilyenkor nem a csoport, hanem a
          //  KIÍRÁS törlése (a csoport és az órái megmaradnak). Ezt kínáljuk fel először.
          const csakKiiras = confirm(`${hiba.error}\n\nOK = csak a tantárgyfelosztásból veszem ki `
            + '(a tanár-hozzárendelés törlődik, a csoport és az órarendi órái megmaradnak).\n'
            + 'Mégse = további lehetőségek.');
          if (csakKiiras) {
            try {
              await this.kiirasTorles(g);
            } catch (e3) {
              alert('A törlés nem sikerült!\n\n' + this.hibaSzoveg(e3));
              return;
            }
            this.editorGroups.splice(i, 1);
            this.ref.detectChanges();
            return;
          }
          const ok = confirm('Magát a csoportot töröljem? Az órák megmaradnak, '
            + 'csak lekerül róluk a csoport (osztályszintűvé válnak), a csoportnak szóló '
            + 'faliújság-bejegyzések viszont törlődnek.');
          if (!ok) return;                       // a sor MARAD a képernyőn
          try {
            await torol(true);
          } catch (e2: any) {
            this.data.sendToast(e2?.error?.error || 'A csoport törlése nem sikerült.', 'error');
            return;
          }
        } else {
          this.data.sendToast(hiba?.error || 'A csoport törlése nem sikerült.', 'error');
          return;                                 // a sor MARAD, hogy ne hazudjunk sikert
        }
      }
    }
    this.editorValtozott = true;
    this.editorGroups.splice(i, 1);
    this.ref.detectChanges();
  }

  isClassChecked(g, oid): boolean { return g.osztalyok.indexOf(oid) !== -1; }

  toggleClass(g, oid) {
    const idx = g.osztalyok.indexOf(oid);
    if (idx === -1) g.osztalyok.push(oid); else g.osztalyok.splice(idx, 1);
  }

  // ---- Csoporthoz terem (kereshető lista, bontáson belül egyszer választható) ----
  // Kereséshez: kisbetűsít + ékezeteket bont (így a "media" megtalálja az
  // "A/2-Média" termet), a '/', '.' és '-' szóközzé alakul (Gizella 36.2e/24.).
  private teremKulcs(s): string {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[\/.,\-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // A modálban listázott tantermek az adott csoport keresőkifejezésére szűrve.
  // Több szó = ÉS kapcsolat ("b torna" → "B/4-6-Torna"). A már kiválasztott terem
  // MINDIG a listában marad (különben eltűnne a jelölése).
  filteredRooms(g) {
    const q = this.teremKulcs(g?.teremSearch);
    const szavak = q ? q.split(' ') : [];
    const lista = !q ? (this.termek || []) : (this.termek || []).filter(r => {
      if (r.id === g?.terem) return true;
      const kulcs = this.teremKulcs((r.name || '') + ' ' + (r.rovid || ''));
      return szavak.every(w => kulcs.includes(w));
    });
    // A KIVÁLASZTOTT terem kerüljön legfelülre: a lista hosszú, és görgetés nélkül
    // nem látszott, mi van éppen beállítva (a pipa lejjebb volt a listában).
    return this.valasztottElore(lista, (r) => r.id === g?.terem);
  }

  /** A kiválasztott elem(ek) a lista elejére – a sorrend egyébként változatlan. */
  private valasztottElore<T>(lista: T[], valasztott: (x: T) => boolean): T[] {
    const be: T[] = [], ki: T[] = [];
    for (const x of lista || []) (valasztott(x) ? be : ki).push(x);
    return be.concat(ki);
  }

  // A bontás MÁSIK csoportja már lefoglalta ezt a termet → itt nem választható.
  // (Ugyanannak a tantárgy×osztály sornak a csoportjai párhuzamos órák.)
  isRoomTaken(g, teremId): boolean {
    if (!teremId) return false;
    return (this.editorGroups || []).some(o => o !== g && o.terem === teremId);
  }

  // Melyik csoport foglalja (1-alapú sorszám) – a "foglalt" felirathoz.
  roomTakenBy(g, teremId): number {
    return (this.editorGroups || []).findIndex(o => o !== g && o.terem === teremId) + 1;
  }

  selectRoom(g, teremId) {
    if (teremId && this.isRoomTaken(g, teremId)) return; // foglalt a bontáson belül
    g.terem = (g.terem === teremId) ? null : teremId;    // újrakattintás = törlés
    this.ref.detectChanges();
  }

  teremNev(teremId): string {
    if (!teremId) return '';
    const r = (this.termek || []).find(t => t.id === teremId);
    return r ? (r.name || r.rovid || '') : '';
  }

  // A csoport terem-felirata a modál fejlécében.
  roomLabel(g): string {
    if (!g || !g.terem) return 'nincs kiválasztva';
    return this.teremNev(g.terem) || g.terem;
  }

  // ---- Csoporthoz TÖBB tanár (társtanítás) ----
  isTeacherChecked(g, adid): boolean { return (g.munkatarsak || []).indexOf(adid) !== -1; }

  toggleTeacher(g, adid) {
    if (!g.munkatarsak) g.munkatarsak = [];
    const idx = g.munkatarsak.indexOf(adid);
    if (idx === -1) g.munkatarsak.push(adid); else g.munkatarsak.splice(idx, 1);
  }

  // A csoporthoz kiválasztott tanárok neveinek felirata a modál fejlécében.
  groupTeacherNames(g): string {
    const arr = (g && g.munkatarsak) || [];
    if (!arr.length) return 'nincs kiválasztva';
    return arr.map(m => this.teacherName(m)).join(', ');
  }

  // A per-osztály sor csoport-chipjei: a tanáronkénti ttfel-sorokat csoportonként
  // összevonjuk, a társtanárok EGY chipben jelennek meg (társtanítás).
  csoportChips(t): any[] {
    const map = new Map<any, any>();
    for (const f of (t && t.ttfel) || []) {
      if (!f || !f.munkatars) continue;
      const key = (f.csoport && f.csoport.id) ? f.csoport.id : 'OSZTALY';
      if (!map.has(key)) {
        map.set(key, {
          id: key,
          idegen: this.idegenSor(f),
          idegenEv: (f.csoport && f.csoport.idegenEv) || null,
          name: (f.csoport && f.csoport.id !== 'OSZTALY') ? (f.csoport.name || '') : '',
          osztalyok: (f.csoport && f.csoport.osztalyok) || [],
          db: f.db,
          // A terem nevét a backend is visszaadja (teremNev), de ha üres, a betöltött
          // terem-törzsből oldjuk fel.
          terem: (f.csoport && (f.csoport.teremNev || this.teremNev(f.csoport.terem))) || '',
          teachers: [],
        });
      }
      const c = map.get(key);
      const nm = this.teacherName(f.munkatars);
      if (c.teachers.indexOf(nm) === -1) c.teachers.push(nm);
      if ((Number(f.db) || 0) > (Number(c.db) || 0)) c.db = f.db;
    }
    return Array.from(map.values());
  }

  /**
   *  A modál tanárlistája. A csoportot átadva a MÁR KIVÁLASZTOTT tanárok kerülnek
   *  legfelülre – hosszú tantestületnél különben görgetni kellett, hogy egyáltalán
   *  látszódjon, ki van bepipálva (és a keresés is elrejthette őket).
   */
  filteredTeachers(g?: any) {
    const q = (this.teacherSearch || '').toLowerCase().trim();
    const lista = !q ? (this.ports || []) : (this.ports || []).filter(p => {
      if (g && (g.munkatarsak || []).indexOf(p.adid) !== -1) return true;   // a kijelölt sose essen ki
      return ((p.viselt_vez || '') + ' ' + (p.viselt_ker || '')).toLowerCase().includes(q);
    });
    if (!g) return lista;
    return this.valasztottElore(lista, (p: any) => (g.munkatarsak || []).indexOf(p.adid) !== -1);
  }

  /* ═══════════════ TANÁR SZERINTI NÉZET ═══════════════
     Egy tanár összes beosztott órája: tantárgy, osztály(ok), csoport, óraszám,
     terem, társtanárok. A sorok kulcsa a ttf-hozzárendelés id-je, ezért a több
     osztályt átfogó (összevont) csoport EGYSZER jelenik meg, minden osztályával. */

  // Kereshető tanár-választó a fülön (nem keverendő a modál teacherSearch-ével)
  tanarKereso = '';
  valasztottTanar: string | null = null;

  /* Üres rács magyarázata. A TTF-rács a KERETTANTERV (óraterv) sorokból épül
     (`ttf.tantargy` = `kerettanterv.id`), ezért ha az adott tanévre nincs kerettanterv,
     a tábla akkor is üres, ha vannak tantárgyfelosztás-sorok. Az „árva" sorok olyan
     kerettanterv-azonosítóra hivatkoznak, ami már nem létezik (törölt óraterv). */
  tanevDiagnosztika: any = null;

  /** Van-e olyan évfolyam, aminek van osztálya, de nincs órterve ebben a tanévben. */
  get hianyzoOraterv(): any[] {
    return (this.tanevDiagnosztika?.hianyzo_oraterv || [])
      // A 0. (óvoda/előkészítő) és a 99-es (technikai) évfolyamnak nincs óraterve – ne riogassunk vele.
      .filter((h: any) => Number(h.evfolyam) > 0 && Number(h.evfolyam) < 90);
  }

  /** A tanévhez kötött törzsadat-hiányok rövid felsorolása (teremválasztó, csoportok). */
  get torzsadatHianyok(): string[] {
    const d = this.tanevDiagnosztika;
    if (!d) return [];
    const ki: string[] = [];
    if (!d.tanterem) ki.push('nincs tanterem rögzítve erre a tanévre (a teremválasztó üres marad)');
    if (!d.tantargy) ki.push('nincs tantárgy erre a tanévre');
    if (!d.osztaly) ki.push('nincs osztály erre a tanévre');
    // Árva sor: olyan kerettanterv-azonosítóra hivatkozik, ami már nem létezik → sehol
    // nem jelenik meg, de a tanári óraszámban sem számít bele. Néma adatvesztés lenne.
    if (d.ttf_arva) {
      ki.push(`${d.ttf_arva} tantárgyfelosztás-sor már nem létező óratervi sorra hivatkozik (nem jelenik meg sehol)`);
    }
    // Másik tanév csoportjára mutató sor: a rács ezt már nem hozza be, de jelezni kell.
    if (d.csoport_idegen_ev) {
      ki.push(`${d.csoport_idegen_ev} sor egy MÁSIK tanév csoportjára hivatkozik – ezeket a rács nem mutatja`);
    }
    return ki;
  }

  private diagnosztikaBetolt() {
    this.tanevDiagnosztika = null;
    this.http.get<any>(`/api/tanev/statusz/${this.akttev}/${this.sajatIntezmeny.intezmenyId}`)
      .subscribe({
        next: (r) => { this.tanevDiagnosztika = r; try { this.ref.detectChanges(); } catch (e) {} },
        error: () => { /* a magyarázat nélkül is működik az oldal */ },
      });
  }

  // Fülváltás: az aSc fül lusta betöltésű (a mezőkatalógus a backendről jön)
  segmentValtas(e: any) {
    this.segment = e?.detail?.value || this.segment;
    if (this.segment === 'asc') this.ascKatalogusBetolt();
  }

  tanarValaszto() {
    const q = this.ekezetKulcs(this.tanarKereso);
    const lista = (this.ports || []).slice().sort((a, b) =>
      String((a.viselt_vez || '') + ' ' + (a.viselt_ker || ''))
        .localeCompare(String((b.viselt_vez || '') + ' ' + (b.viselt_ker || '')), 'hu'));
    if (!q) return lista;
    return lista.filter(p => this.ekezetKulcs((p.viselt_vez || '') + ' ' + (p.viselt_ker || '')).includes(q));
  }

  // Ékezet- és írásjel-tűrő keresőkulcs (a teremválasztóval azonos elv)
  private ekezetKulcs(s: any): string {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  valasztTanar(adid: string) {
    this.valasztottTanar = adid;
    try { this.ref.detectChanges(); } catch (e) {}
  }

  get valasztottTanarAdat() {
    return (this.ports || []).find(p => p.adid == this.valasztottTanar) || null;
  }

  // A kiválasztott tanár órái (egy sor / ttf-hozzárendelés)
  tanarOrai(): any[] {
    const adid = this.valasztottTanar;
    if (!adid || !this.ttf) return [];
    const terkep = new Map<string, any>();

    for (const t of this.ttf) {
      //  Az évfolyam-szintű teljes lista (_allttfel) a forrás, nem az osztályra szűrt
      //  ttfel: ami egyik osztály sorába sem került be, annak az óraszáma is számít.
      //  (Korábban az osztályhoz nem kötött csoport órái itt elvesztek – Zenit,
      //  2026-10-07: 24 órarendi órából 11 látszott.) A kulcs a ttf-sor id-je, így a
      //  több osztálynál is megjelenő sor egyszer számít.
      const mind = t._allttfel || t.ttfel || [];
      for (const f of mind) {
        if (!f || f.munkatars != adid) continue;
        const csId = f.csoport?.id || 'OSZTALY';
        const kulcs = String(f.id || (t.id + '|' + csId));

        if (!terkep.has(kulcs)) {
          // Társtanárok: ugyanazon a csoporton lévő MÁSIK tanárok
          const tarsak: string[] = [];
          for (const g of mind) {
            if (!g || g.munkatars == adid) continue;
            if ((g.csoport?.id || 'OSZTALY') !== csId) continue;
            const nev = this.teacherName(g.munkatars);
            if (!tarsak.includes(nev)) tarsak.push(nev);
          }
          terkep.set(kulcs, {
            tantargy: t.nev,
            rovid: t.rovid,
            evfolyam: t.evfolyam?.evfolyam,
            csoportNev: csId === 'OSZTALY' ? '' : (f.csoport?.name || ''),
            egeszOsztaly: csId === 'OSZTALY',
            idegen: this.idegenSor(f),
            idegenEv: f.csoport?.idegenEv || null,
            terem: f.csoport?.teremNev || '',
            db: Number(f.db) || 0,
            osztalyok: [] as string[],
            tarsak,
          });
        }
        const sor = terkep.get(kulcs);
        // Osztálynév csak onnan, ahol a sor ténylegesen megjelenik.
        const oNev = t.evfolyam?.osztaly;
        if (oNev && (t.ttfel || []).includes(f) && !sor.osztalyok.includes(oNev)) sor.osztalyok.push(oNev);
      }
    }

    return [...terkep.values()].sort((a, b) =>
      this.osztalyStrCompare(a.osztalyok[0] || '', b.osztalyok[0] || '')
      || String(a.tantargy || '').localeCompare(String(b.tantargy || ''), 'hu'));
  }

  // A tanár összóraszáma a fenti listából (megegyezik a "Tanárok óraszáma" fül értékével)
  tanarOsszOra(): number {
    return this.tanarOrai().reduce((s, o) => s + (o.idegen ? 0 : (Number(o.db) || 0)), 0);
  }

  // Kötelező óraszám (részmunkaidő + órakedvezmény figyelembevételével)
  tanarKotelezoOra(): number {
    const p: any = this.valasztottTanarAdat;
    if (!p) return 0;
    return this.kotelezoOra(p);
  }

  /*  Egy munkatárs kötelező óraszáma: 24 × részmunkaidő-arány − órakedvezmény.
   *  ÓRAADÓNÁL (megbízás, shared/oraado.ts) nincs arány és kötött munkaidő: a szerződés
   *  szerinti heti óraszám a mérce (ha nincs rögzítve, 0 – nincs mihez mérni). */
  kotelezoOra(p: any): number {
    // Ha a 105. § szerinti adatok betöltődtek, azok a mérvadók: a rögzített lekötött óraszám,
    // illetve a kinevezéseken felüli órakedvezmény-jogcímekkel is csökkentett számított érték.
    const rogzitett = this.jog?.lekotott(p?.adid);
    if (rogzitett !== null && rogzitett !== undefined && !Number.isNaN(rogzitett)) return rogzitett;
    const ia = p?.intezmenyadatok || {};
    if (oraadoJogviszony(ia.munkaviszony)) return hetiOraszam(ia.heti_oraszam) || 0;
    const arany = ia.reszm_arany;
    return arany == null
      ? 24 - (p?.orakedvezmeny || 0)
      : Math.round(arany / 100 * 24 - (p?.orakedvezmeny || 0));
  }

  // Mely osztályoknak osztályfőnöke
  tanarOsztalyfonokseg(): string {
    return (this.osztaly || [])
      .filter(o => o.of == this.valasztottTanar)
      .map(o => o.osztaly).join(', ') || '-';
  }

  tanarOsztalyLista(sor: any): string {
    return (sor.osztalyok || []).slice()
      .sort((a, b) => this.osztalyStrCompare(a, b)).join(', ');
  }

  /*  A tanár óráinak PDF-je a kiszolgáló riport-motorjával (backend/pdf-riport.js) – a
   *  munkaidő-elszámolás arculatával. A más tanévi / törölt csoportra mutató kiírás (idegen)
   *  halványan, megjegyzéssel áll, és – mint a képernyőn – nem számít az összesbe. Hiba
   *  esetén a régi, böngészős PDF készül. */
  async printTanar() {
    const p: any = this.valasztottTanarAdat;
    if (!p) { alert('Előbb válassz tanárt!'); return; }
    const nev = `${p.viselt_vez || ''} ${p.viselt_ker || ''}`.trim();
    const fajlnev = `ttf-${nev.replace(/\s+/g, '-').toLowerCase()}-${this.akttev}.pdf`;
    const tanev = this.tanev?.name || String(this.akttev || '');
    const orak = this.tanarOrai();
    const ossz = this.tanarOsszOra();
    const kotelezo = this.tanarKotelezoOra();
    const sorok: RiportSor[] = orak.map((o: any) => {
      const idegen = o.idegen ? ` – ${o.idegenEv ? o.idegenEv + '. tanévi' : 'törölt'} csoport, nem számít bele` : '';
      return [
        { t: this.tanarOsztalyLista(o), fej: true },
        o.tantargy || '',
        { t: (o.egeszOsztaly ? 'egész osztály' : (o.csoportNev || '')) + idegen, halvany: !!o.idegen },
        o.idegen ? { t: `(${o.db})`, halvany: true } : String(o.db),
        o.terem || '–',
        (o.tarsak || []).length ? o.tarsak.join(', ') : '–',
      ];
    });
    try {
      await this.data.riportPdf({
        intezmeny: this.sajatIntezmeny?.intezmenyId,
        cim: 'Tantárgyfelosztás',
        cimKieg: 'tanári lap',
        alcim: `${nev} · ${tanev}`,
        adatsav: [['Tanár', nev], ['Tanév', tanev], ['Kiosztott / kötelező', `${ossz} / ${kotelezo} óra`],
          ['Osztályfőnök', this.tanarOsztalyfonokseg()]],
        lapmeret: 'A4', tajolas: 'allo', betumeret: 8.5,
        tablak: [{
          cim: 'Heti órák', osszegzes: `${ossz} óra`,
          oszlopok: [
            { nev: 'Osztály', szelesseg: '14%' }, { nev: 'Tantárgy', szelesseg: '24%' },
            { nev: 'Csoport', szelesseg: '22%' }, { nev: 'Heti óra', igazitas: 'kozep', szelesseg: '9%' },
            { nev: 'Terem', szelesseg: '11%' }, { nev: 'Társtanár', szelesseg: '20%' },
          ],
          sorok,
          osszesen: orak.length ? [{ t: 'Összesen', cs: 3 }, { t: String(ossz), igazitas: 'kozep' }, { t: '', cs: 2 }] : undefined,
          ures: 'Ehhez a tanárhoz nincs beosztott óra ebben a tanévben.',
        }],
        lablec: {
          kelt: true, alairok: [nev || 'Pedagógus', 'Intézményvezető'], keszitette: this.sajatnev,
          ...(orak.some((o: any) => o.idegen)
            ? { megjegyzes: 'A zárójeles óraszám más tanévi vagy törölt csoportra mutató kiírás – a tanár óraszámába nem számít bele (a Szerkesztésben törölhető).' } : {}),
        },
        fajlnev,
      }, fajlnev, 'letolt');
    } catch (e: any) {
      console.warn('Tanári TTF-lap PDF (kiszolgáló) hiba, böngészős tartalék:', e);
      this.data.sendToast(`A PDF a régi formában készült (${e?.message || e}).`, 'warning');
      this.printTanarRegi();
    }
  }

  // A tanár óráinak PDF-je (a rácsnyomtatással azonos betűkészlettel) – tartalék
  printTanarRegi() {
    const p: any = this.valasztottTanarAdat;
    if (!p) { alert('Előbb válassz tanárt!'); return; }
    const nev = `${p.viselt_vez || ''} ${p.viselt_ker || ''}`.trim();

    const pdf = new jsPDF('p', 'mm', 'a4');
    pdf.addFileToVFS('Bitter-Regular-normal.ttf', font);
    pdf.addFont('Bitter-Regular-normal.ttf', 'Bitter-Regular', 'normal');
    pdf.addFileToVFS('Bitter-Bold-normal.ttf', fontB);
    pdf.addFont('Bitter-Bold-normal.ttf', 'Bitter-Bold', 'bold');
    pdf.setFont('Bitter-Regular');

    const cim = `${this.replaceAccentedChars(nev)} orai - ${this.tanev?.name || this.akttev}`;
    pdf.text(cim, pdf.internal.pageSize.width / 2 - pdf.getTextWidth(cim) / 2, 12);

    const body = this.tanarOrai().map(o => [
      this.replaceAccentedChars(this.tanarOsztalyLista(o)),
      this.replaceAccentedChars(o.tantargy || ''),
      o.egeszOsztaly ? 'egesz osztaly' : this.replaceAccentedChars(o.csoportNev || ''),
      String(o.db),
      this.replaceAccentedChars(o.terem || ''),
      this.replaceAccentedChars((o.tarsak || []).join(', ')),
    ]);
    body.push(['', 'Osszesen', '', String(this.tanarOsszOra()), '', '']);

    autoTable(pdf, {
      theme: 'grid',
      startY: 18,
      head: [['Osztaly', 'Tantargy', 'Csoport', 'Ora', 'Terem', 'Tarstanar']],
      body,
      styles: {
        lineColor: [0, 0, 0], textColor: [0, 0, 0], overflow: 'linebreak',
        fontSize: 8, cellPadding: 1.5, font: 'Bitter-Regular', valign: 'middle',
      },
      headStyles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] },
    });
    pdf.save(`ttf-${nev.replace(/\s+/g, '-').toLowerCase()}-${this.akttev}.pdf`);
  }

  /* ═══════════════ aSc XML EXPORT ═══════════════
     A TTF-ből aSc-be importálható XML. Két dolog fontos:
      - az azonosítókat a backend tartja nyilván (asc_azonosito), így az aSc-ben
        átnevezett csoport/osztály FRISSÜL, nem duplikálódik;
      - csak a bepipált mezők kerülnek az XML `columns` listájába, az aSc pedig
        CSAK azokat írja felül – így pl. az aSc-ben beállított osztályterem marad. */

  ascKatalogus: any = null;      // /orarend/ascexport/mezok válasza
  ascReszek: any = {};           // { periods: true, ... }
  ascMezok: any = {};            // { teachers: ['short', ...], ... }
  ascStat: any = null;
  ascFolyamatban = false;

  async ascKatalogusBetolt() {
    if (this.ascKatalogus) return;
    try {
      const r: any = await this.http.get('/api/orarend/ascexport/mezok').toPromise();
      this.ascKatalogus = r;
      for (const resz of r.reszek) this.ascReszek[resz.kulcs] = !!resz.alap;
      for (const szekcio of Object.keys(r.mezok || {})) {
        this.ascMezok[szekcio] = (r.mezok[szekcio] || []).filter(m => m.alap).map(m => m.kulcs);
      }
      try { this.ref.detectChanges(); } catch (e) {}
    } catch (e) {
      console.error('aSc mezőkatalógus betöltési hiba:', e);
    }
  }

  // A mező-pipálók szekciói (a katalógus kulcsaihoz magyar címke, a rész-pipa szerint szűrve)
  ascSzekciok(): Array<{ kulcs: string; cim: string; mezok: any[] }> {
    if (!this.ascKatalogus?.mezok) return [];
    const cimek: any = {
      teachers: 'Tanárok', classrooms: 'Tantermek', classes: 'Osztályok',
      subjects: 'Tantárgyak', lessons: 'Órák / beosztás',
    };
    return Object.keys(this.ascKatalogus.mezok)
      .filter(k => this.ascReszek[k])
      .map(k => ({ kulcs: k, cim: cimek[k] || k, mezok: this.ascKatalogus.mezok[k] || [] }));
  }

  ascMezoBe(szekcio: string, kulcs: string): boolean {
    return (this.ascMezok[szekcio] || []).includes(kulcs);
  }

  ascMezoValt(szekcio: string, kulcs: string) {
    const lista = this.ascMezok[szekcio] || (this.ascMezok[szekcio] = []);
    const i = lista.indexOf(kulcs);
    if (i >= 0) lista.splice(i, 1); else lista.push(kulcs);
  }

  private ascOpciok() {
    return { ev: this.akttev, reszek: this.ascReszek, mezok: this.ascMezok };
  }

  async ascElonezet() {
    this.ascFolyamatban = true;
    this.ascStat = null;
    try {
      const r: any = await this.http
        .post('/api/orarend/ascexport-elonezet/' + this.sajatIntezmeny.intezmenyId, this.ascOpciok())
        .toPromise();
      this.ascStat = r;
    } catch (e: any) {
      console.error('aSc előnézet hiba:', e);
      alert(e?.error?.error || 'Nem sikerült elkészíteni az előnézetet.');
    } finally {
      this.ascFolyamatban = false;
      try { this.ref.detectChanges(); } catch (er) {}
    }
  }

  async ascLetoltes() {
    this.ascFolyamatban = true;
    try {
      const blob: any = await this.http
        .post('/api/orarend/ascexport/' + this.sajatIntezmeny.intezmenyId, this.ascOpciok(),
          { responseType: 'blob' as 'json' })
        .toPromise();
      const url = window.URL.createObjectURL(blob as Blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `asc-export-${this.akttev}.xml`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e: any) {
      console.error('aSc export hiba:', e);
      alert('Nem sikerült elkészíteni az aSc XML-t.');
    } finally {
      this.ascFolyamatban = false;
      try { this.ref.detectChanges(); } catch (er) {}
    }
  }

  teacherName(munkatars) {
    const p = this.ports.find(a => a.adid == munkatars);
    return p ? (p.viselt_vez + ' ' + p.viselt_ker) : (munkatars || '-');
  }

  // A csoporthoz tartozó osztályok nevének összefűzése a chip-felirathoz.
  joinClasses(osztalyok) {
    if (!osztalyok || !osztalyok.length) return '';
    return osztalyok.slice().sort((a, b) => this.osztalyStrCompare(a.osztaly, b.osztaly)).map(o => o.osztaly).join(', ');
  }

  // A modál mentése: minden csoportra biztosítja a csoport-rekordot, az osztály-
  // készletet és a tanár+óraszám (ttf) hozzárendelést.
  async saveEditor() {
    if (this.savingEditor) return;
    //  Tanár nélkül is menthető: ha egy meglévő tételről MINDEN tanárt leveszel, a kiírása
    //  törlődik (a csoport megmarad). Korábban legalább egy tanárt követelt a mentés, és a
    //  tanár nélküli csoportot csendben kihagyta – így a kiírást nem lehetett törölni.
    //  Új, tanár nélküli csoportot viszont nem hozunk létre (nem lenne mihez kötni).
    const mind = (this.editorGroups || []);
    const groups = mind.filter(g => (g.munkatarsak && g.munkatarsak.length) || (g.origAssignments || []).length);
    const kiuritett = groups.filter(g => !(g.munkatarsak || []).length);
    if (groups.length === 0) {
      this.closeEditor();
      return;
    }
    if (kiuritett.length && !confirm(`${kiuritett.length} tételről minden tanárt levettél – `
      + 'a kiírásuk törlődik a tantárgyfelosztásból (a csoport megmarad). Folytatod?')) {
      return;
    }
    // Egy terem a bontáson belül csak egy csoporté lehet (a lista tiltja, de a
    // mentés előtt is ellenőrizzük – pl. ha a terem törlődött időközben a listáról).
    const foglalt = groups.filter(g => g.terem).map(g => g.terem);
    const dupla = foglalt.find((t, i) => foglalt.indexOf(t) !== i);
    if (dupla) {
      alert('Ugyanaz a terem több csoporthoz van rendelve ebben a bontásban: ' + (this.teremNev(dupla) || dupla));
      return;
    }
    this.savingEditor = true;
    this.ref.detectChanges();
    const intezmeny = this.sajatIntezmeny.intezmenyId;
    const kt = this.editorRow.id;
    try {
      for (const g of groups) {
        const name = (g.name && g.name.trim()) || (this.editorRow.nev + '/' + (groups.indexOf(g) + 1));
        // Ha nincs osztály kiválasztva, essen vissza az aktuális sor osztályára,
        // különben a per-osztály nézetben nem jelenne meg a csoport.
        const osztalyok = (g.osztalyok && g.osztalyok.length)
          ? g.osztalyok
          : (this.editorClassId ? [this.editorClassId] : []);
        // Kiürített tétel: csak a kiírás törlése, a csoporthoz nem nyúlunk.
        if (!(g.munkatarsak || []).length) {
          await this.kiirasTorles(g);
          continue;
        }
        //  A másik tanév csoportjára mutató sor csoportját NEM írjuk (lezárt tanév adata).
        if (!g.egeszOsztaly && !g.idegen) {
          // 1) csoport rekord (a terem a csoporton van → bontásonként külön terem)
          const terem = g.terem || null;
          if (!g.csoportId) {
            const r: any = await this.http.post('/api/csoport',
              { intezmeny, ev: this.akttev, name, terem }).toPromise();
            g.csoportId = r && r.id;
          } else {
            await this.http.patch('/api/csoport/' + g.csoportId, { name, terem }).toPromise();
          }
          // 2) osztály-készlet
          await this.http.put('/api/csoport/' + g.csoportId + '/osztaly',
            { intezmeny, osztalyok }).toPromise();
        }
        // 3) tanárok (társtanítás → csoportonként TÖBB ttf sor, mind ugyanazzal az
        //    óraszámmal). Diff az eredetihez: leszedett törlése, megmaradó óraszám-
        //    frissítése, új tanár beszúrása. A tanár azonosítója az adid.
        const db = Number(g.db) || 0;
        const orig = g.origAssignments || [];
        const wanted = g.munkatarsak || [];
        for (const a of orig) {
          if (wanted.indexOf(a.munkatars) === -1) {
            this.assertTtfOk(await this.http.delete('/api/ttf/' + a.ttfId).toPromise());
          }
        }
        for (const m of wanted) {
          const existing = orig.find(a => a.munkatars === m);
          if (existing) {
            this.assertTtfOk(await this.http.patch('/api/ttf/' + existing.ttfId, [db]).toPromise());
          } else {
            // Egész osztályos tételnél a csoport marad NULL (6. elem nélkül).
            this.assertTtfOk(await this.http.post('/api/ttf',
              [db, kt, m, this.akttev, intezmeny, g.egeszOsztaly ? null : g.csoportId]).toPromise());
          }
        }
      }
      this.closeEditor();
      this.populateDaysInMonth();
    } catch (e) {
      console.error('Mentési hiba:', e);
      alert('A mentés nem sikerült!\n\n' + this.hibaSzoveg(e) + '\n\nRészletek a konzolban.');
    } finally {
      this.savingEditor = false;
      this.ref.detectChanges();
    }
  }

  // A backend POST/PATCH/DELETE /ttf HIBÁNÁL IS HTTP 200-at ad {error:{...}} törzzsel,
  // így az await sikeresnek tűnik. Ezzel kényszerítjük ki a valódi hibát.
  private assertTtfOk(r: any) {
    if (r && r.error) throw r.error;
  }

  // Olvasható hibaszöveg a különböző hibaformákból (SQL üzenet, backend {error}, HTTP).
  private hibaSzoveg(e: any): string {
    if (!e) return 'Ismeretlen hiba.';
    if (typeof e === 'string') return e;
    const sql = e.sqlMessage || e?.error?.sqlMessage || e?.error?.error?.sqlMessage;
    if (sql) return sql;
    const inner = e?.error?.error || e?.error;
    if (typeof inner === 'string') return inner;
    return e.message || JSON.stringify(e);
  }

  logout() {

  }

  initModal(a,b=0){

  }


  startSelection(i: number, j: number) {
    this.isSelecting = true;
    this.addSelection(i, j);
  }

  dragSelection(i: number, j: number) {
    if (this.isSelecting) {
      this.addSelection(i, j);
    }
  }

  endSelection() {
    this.isSelecting = false;
  }

  isSelected(i: number, j: number): boolean {
    return this.selectedCells.has(`${i}-${j}`);
  }

  private addSelection(i: number, j: number) {
    this.selectedCells.add(`${i}-${j}`);
  }

  mouseUpEvent() {
    this.isSelecting = false;
    console.log(Array.from(this.selectedCells)); // Do something with the array of selected cells
  }

  replaceAccentedChars(str) {
    return str
    var accents =    "ő_∑_ű_";
    var accentsOut = 'o"E u"';
    str = str.split('');
    var strLen = str.length;
    var i, x;
    for (i = 0; i < strLen; i++) {
      x = accents.indexOf(str[i]);
      if (x !== -1) {
        str[i] = accentsOut[x]+accentsOut[x+1];
      }
    }
    return str.join('');
  }

  /*  A TELJES TANTÁRGYFELOSZTÁS (kereszttábla: tantárgy×osztály sorok, tanár-oszlopok)
   *  A3 fekvő lapon, a kiszolgáló riport-motorjával (backend/pdf-riport.js) – a munkaidő-
   *  elszámolás arculatával. A tanárnevek függőlegesen állnak (a keskeny oszlopot így nem a
   *  név feszíti szét), a fejléc minden oldalon ismétlődik, az osztályok csoportsorral
   *  válnak el. Ha a tanárok egy lapszélességre nem férnek ki, a tábla oszlop-darabokra
   *  bomlik (mindegyik új oldalon, az Osztály/Tantárgy oszlopokkal). Hiba esetén a régi,
   *  böngészős PDF készül. */
  async printData2() {
    const fajlnev = this.selectedYear + "-" + this.selectedMonth + "_" + this.sajatIntezmeny?.intezmenyName + ".pdf";
    const tanarok: any[] = this.ports || [];
    const tantargyak: any[] = this.ttf || [];
    if (!tantargyak.length) { this.printData2Regi(); return; }
    const tanev = this.tanev?.name || String(this.akttev || '');
    const nev = (p: any) => `${p.viselt_vez || ''} ${p.viselt_ker || ''}`.trim();
    const ora = (t: any, p: any) => (t.ttfel || []).filter((f: any) => f && f.munkatars == p.adid)
      .reduce((s: number, f: any) => s + (Number(f.db) || 0), 0);

    //  Egy A3 fekvő lapra ~64 keskeny (5,5 mm-es) tanár-oszlop fér az Osztály/Tantárgy mellé.
    const MAX = 64;
    const darabDb = Math.max(1, Math.ceil(tanarok.length / MAX));
    const meret = Math.ceil(tanarok.length / darabDb) || 1;
    const tablak: RiportTabla[] = [];
    for (let d = 0; d < darabDb; d++) {
      const resz = tanarok.slice(d * meret, (d + 1) * meret);
      const sorok: RiportSor[] = [];
      let osztaly: string | null = null;
      for (const t of tantargyak) {
        const o = String(t.evfolyam?.osztaly || '');
        if (o !== osztaly) { sorok.push({ csoport: o || '(osztály nélkül)' }); osztaly = o; }
        sorok.push([o, { t: t.nev || '', fej: true }, ...resz.map((p) => { const h = ora(t, p); return h ? String(h) : ''; })]);
      }
      tablak.push({
        cim: darabDb > 1
          ? `Tantárgyfelosztás – tanárok ${d * meret + 1}–${d * meret + resz.length} / ${tanarok.length}`
          : 'Tantárgyfelosztás',
        osszegzes: tanev,
        oszlopok: [
          { nev: 'Osztály', szelesseg: '14mm' },
          { nev: 'Tantárgy', szelesseg: '34mm' },
          ...resz.map((p) => ({ nev: nev(p), igazitas: 'kozep' as const, fuggoleges: true })),
        ],
        sorok,
        osszesen: [{ t: '' }, { t: 'Összes óra' }, ...resz.map((p) => ({ t: p.osszora ? String(p.osszora) : '', igazitas: 'kozep' as const }))],
        ujOldal: d > 0,
      });
    }
    try {
      await this.data.riportPdf({
        intezmeny: this.sajatIntezmeny?.intezmenyId,
        cim: 'Tantárgyfelosztás',
        cimKieg: tanev,
        alcim: this.sajatIntezmeny?.intezmenyName || '',
        adatsav: [['Tanév', tanev], ['Tanárok', String(tanarok.length)], ['Tantárgy-sorok', String(tantargyak.length)]],
        lapmeret: 'A3', tajolas: 'fekvo', betumeret: 7,
        tablak,
        lablec: { kelt: true, alairok: ['Készítette', 'Intézményvezető'], keszitette: this.sajatnev },
        fajlnev,
      }, fajlnev, 'letolt');
    } catch (e: any) {
      console.warn('TTF PDF (kiszolgáló) hiba, böngészős tartalék:', e);
      this.data.sendToast(`A PDF a régi formában készült (${e?.message || e}).`, 'warning');
      this.printData2Regi();
    }
  }

  printData2Regi()
  {
   this.isadmin=false;
   this.ref.detectChanges()
    const table = document.getElementById('printable2') as HTMLTableElement;

    let pdf = new jsPDF('l', 'mm', 'a3');

        // Extract the selected values from the table
      /*  const datas = [];
        const rows = Array.from(table.rows);  // Convert HTMLCollection to an array
        rows.forEach(row => {
          const rowData = [];
          const cells = Array.from(row.cells);  // Convert HTMLCollection to an array
          cells.forEach((cell:any) => {
            //console.log(cell)
            const select: IonSelect = cell.querySelector('.mySelect');
            console.log(select?.value)
            rowData.push(select?.value ? select?.value : "");
          });
          datas.push(rowData);
        });*/

    //pdf.setFont('Bitter-Regular', 'normal')
    pdf.addFileToVFS("Bitter-Regular-normal.ttf", font);
    pdf.addFont("Bitter-Regular-normal.ttf", "Bitter-Regular", "normal");
    pdf.addFileToVFS("Bitter-Bold-normal.ttf", fontB);
    pdf.addFont("Bitter-Bold-normal.ttf", "Bitter-Bold", "bold");
    pdf.setFont("Bitter-Regular");

    //pdf.text("Tantárgyfelosztás "+this.selectedYear+"-"+this.selectedMonth,115, 10);
pdf.text("Tantárgyfelosztás " + this.selectedYear + "-" + this.selectedMonth, pdf.internal.pageSize.width / 2 - pdf.getTextWidth("Tantárgyfelosztás " + this.selectedYear + "-" + this.selectedMonth) / 2, 10);


    function getBackgroundColor(cell) {
      return window.getComputedStyle(cell, null).getPropertyValue('background-color');
    }

    let nem = "data:image/png;base64,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"
    let igen = "data:image/png;base64,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"

    //console.log(pdf.getFontList());
    // ---- Kereszttábla: tanár OSZLOPOK, tantárgy(×osztály) SOROK ----
    const __ttfTeachers = (this.ports || []);
    const __ttfHead = [[ 'Osztály', 'Tantárgy', ...__ttfTeachers.map(p => this.replaceAccentedChars(p.viselt_vez || '') + ' ' + this.replaceAccentedChars(p.viselt_ker || '')) ]];
    const __ttfBody: any[] = (this.ttf || []).map(t => {
      const row: any[] = [ this.replaceAccentedChars(t.evfolyam?.osztaly || ''), this.replaceAccentedChars(t.nev || '') ];
      for (const p of __ttfTeachers) {
        const hrs = (t.ttfel || []).filter(f => f && f.munkatars == p.adid).reduce((s, f) => s + (Number(f.db) || 0), 0);
        row.push(hrs ? hrs : '');
      }
      return row;
    });
    { const tr: any[] = ['', 'Összes óra']; for (const p of __ttfTeachers) tr.push(p.osszora ? p.osszora : ''); __ttfBody.push(tr); }
    const __ttfColStyles: any = { 0: { halign: 'left', cellWidth: 14 }, 1: { halign: 'left', cellWidth: 34 } };
    for (let i = 0; i < __ttfTeachers.length; i++) __ttfColStyles[i + 2] = { cellWidth: 5, halign: 'center' };
    autoTable(pdf,
      { theme: 'grid',
        head: __ttfHead,
        body: __ttfBody,
        styles: { lineColor:[0, 0, 0],textColor:[0, 0, 0],overflow: 'linebreak', fontSize: 6, cellPadding: 1, font: 'Bitter-Regular', halign : 'center', valign: 'middle' },
        columnStyles: __ttfColStyles,
        headStyles :{textColor:[255, 255, 255],fillColor : [56, 128, 255], fontStyle: 'bold', font: 'Bitter-Bold', valign: 'bottom', minCellHeight: 34 },
        willDrawCell: (data) => {
          //console.log(data)
          const cell = data.cell;
          const rowIndex = data.row.index;
          const columnIndex = data.column.index;
          //data.cell.styles.fillColor = [255, 255, 255]
         // console.log(cell.text[0])
          /*if (cell.raw && cell.raw["outerHTML"]?.includes('ion-select')) {
            //console.log("ok")
          cell.text = [datas[rowIndex][columnIndex] ? datas[rowIndex][columnIndex]+"" : "0"];
          
        }*/
          if(cell.text[0] == '  ') {
            pdf.setFillColor("#d3d3d3"); // Set the background color
            pdf.rect(cell.x, cell.y, cell.width, cell.height, 'F');
          }else if(cell.text[0] == ''){
            /*if(cell.raw["outerHTML"].includes("close"))
              pdf.addImage(nem, 'PNG', cell.x + cell.width/2 - 1.5, cell.y + 2 + 7, 3, 3);
            else if(cell.raw["outerHTML"].includes("checkmark"))
              pdf.addImage(igen, 'PNG', cell.x + cell.width/2 - 1.5, cell.y + 2 + 7, 3, 3);*/

            //pdf.text("!",cell.x+2, celltextPos.y + (cell.height - imageHeight) / 2);
          }else{
            //pdf.text("!",cell.x+2, cell.y+2);
          }
          /*if (data.section === 'body' && data.column.index === 0) {
            var base64Img = 'data:image/jpeg;base64,iVBORw0KGgoAAAANS...'
            pdf.addImage(base64Img, 'JPEG', data.cell.x + 2, data.cell.y + 2, 10, 10)
          }*/
        },
        didParseCell: (data) => {
          // A tanár-fejléceket függőlegesre forgatjuk: a vízszintes szöveget kivesszük,
          // hogy az oszlopszélességet ne a hosszú név feszítse szét.
          if (data.section === 'head' && data.column.index >= 2) {
            (data.cell as any)._rot = (data.cell.text || []).join(' ');
            data.cell.text = [''];
          }
        },
        didDrawCell: (data) => {
          if (data.section === 'head' && data.column.index >= 2) {
            const label = (data.cell as any)._rot || '';
            pdf.setFont('Bitter-Bold');
            pdf.setFontSize(6);
            pdf.setTextColor(255, 255, 255);
            pdf.text(String(label), data.cell.x + data.cell.width / 2 + 2, data.cell.y + data.cell.height - 2, { angle: 90 } as any);
          }
        },
        didDrawPage:(data)=>{
          var pageSize = pdf.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          var pageWidth = pageSize.width
            ? pageSize.width
            : pageSize.getWidth();
          pdf.setFontSize(8);
          var img = new Image(); //this mount a variable to img
          img.src = '/assets/icon/favicon.png' //asign the src to the img variable
          pdf.addImage(img, 'png', data.settings.margin.left, pageHeight - 15, 10, 10)// use the method doc.autoTable.previous.finalY + lineHeight * 1.5 + offsetY to be able to position the image of the signature below the table at a safe distance from it

          pdf.text("Készült a Sulinform ERP rendszerében "+moment().format("YYYY-MM-DD HH:mm")+". Generálta: "+ this.sajatnev, data.settings.margin.left+10, pageHeight - 10);
          pdf.text(data.pageNumber+"", pageWidth - 20, pageHeight - 10);
        },
      })

    //table.fromHTML()
    pdf.save(this.selectedYear+"-"+this.selectedMonth+"_"+this.sajatIntezmeny.intezmenyName+".pdf")
    this.isadmin=true;
    this.ref.detectChanges()
  }

  diffDateHours(start, end) {
    try {
      return (
        Math.abs(new Date(end).getTime() - new Date(start).getTime()) / 36e5
      ).toFixed(2);
    } catch (error) {
      return '-';
    }
  }

  createMessageHandler(iframe: HTMLIFrameElement) {
    return function handleMessage(event: MessageEvent) {
      if (event.data.allApiCallsCompleted) {
        setTimeout(() => {
          iframe.contentWindow?.print();
          // Remove the event listener after printing

        }, 1000);
        window.removeEventListener('message', handleMessage, false);
      }
    };
  }

  printUrl(url: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url+"&sajatintezmeny="+JSON.stringify(this.sajatIntezmeny);

    iframe.onload = () => {
      try {
        // Wait for the content to load fully before printing
        const messageHandler = this.createMessageHandler(iframe);

// Add the event listener using the handler function
        window.addEventListener('message', messageHandler, false);

      } catch (error) {
        console.error('Error printing iframe content:', error);
      } finally {
        // Remove the iframe after a delay to ensure print dialog appears
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 5000);
      }
    };

    document.body.appendChild(iframe);
  }
}

